import Header from "@/components/sections/Header";
import Hero from "@/components/sections/Hero";
import Marquee from "@/components/sections/Marquee";
import About from "@/components/sections/About";
import Services from "@/components/sections/Services";
import Approach from "@/components/sections/Approach";
import Sessions from "@/components/sections/Sessions";
import FirstSession from "@/components/sections/FirstSession";
import Testimonials from "@/components/sections/Testimonials";
import Insights from "@/components/sections/Insights";
import FAQ from "@/components/sections/FAQ";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";

export default function Home() {
  return (
    <main className="bg-background text-foreground antialiased">
      <Header />
      <Hero />
      <Marquee />
      <About />
      <Services />
      <Approach />
      <Sessions />
      <FirstSession />
      <Testimonials />
      <Insights />
      <FAQ />
      <Contact />
      <Footer />
    </main>
  );
}
